import { PureComponent } from 'react';

import { eyeClosed, eyeOpened } from '../../../assets/icons';
import { Input } from '../index';
import { IInputProps } from '../Input/Input';

interface IPasswordInput {
    showPassword: boolean;
}

class PasswordInput extends PureComponent<IInputProps, IPasswordInput> {

    public state = {
        showPassword: false,
    };

    public render() {
        const { showPassword } = this.state;
        return (
            <Input
                {...this.props}
                inputtype={(showPassword) ? 'text' : 'password'}
                righticon={(showPassword) ? eyeOpened : eyeClosed}
                righticonhandler={this.switchPasswordDisplay}
            />
        );
    }

    private switchPasswordDisplay = (): void => {
        this.setState((prevState: IPasswordInput) => {
            return {
                showPassword: !prevState.showPassword,
            };
        });
    }
}

export default PasswordInput;
